var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('kanban-board', {
    attrs: {
      "blocks": _vm.applications,
      "stages": _vm.stages,
      "config": _vm.config
    },
    on: {
      "update-block": _vm.applicationMoved
    }
  }, [_vm._l(_vm.stages, function (stage, index) {
    return _c('div', {
      key: stage,
      staticClass: "light-text small",
      attrs: {
        "slot": stage
      },
      slot: stage
    }, [_c('h2', {
      staticClass: "pop-800 blc-color text-uppercase header-custom"
    }, [_c('h2', {
      staticClass: "div-block-110 bordered"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" " + _vm._s(_vm.getLabel(stage)) + " ")])]);
  }), _vm._l(_vm.applications, function (application, index) {
    return _c('div', {
      key: index,
      staticClass: "ziadost-item-custom pointer position-relative",
      "class": {
        'editing': _vm.isEditable(application)
      },
      attrs: {
        "slot": application.id
      },
      slot: application.id
    }, [_vm.show ? _c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.removeApplication(application);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": application.bank.logo_square
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "ziadost-top"
    }, [_c('div', {
      staticClass: "ziadost-icon"
    }, [_c('img', {
      staticClass: "bank-logo",
      attrs: {
        "src": application.bank.logo_square,
        "loading": "lazy",
        "alt": ""
      }
    }), _c('div', {
      staticClass: "text-part"
    }, [_c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(application.suma_nadobudnutie + application.suma_refinancovanie + application.suma_bezucel) + " EUR")]), _c('div', [_vm._v(_vm._s(application.splatka) + " EUR")]), application.status === 'schvalena' && application.stage === 'schvalena' ? _c('div', {
      staticClass: "text-cta pointer",
      on: {
        "click": function click($event) {
          return _vm.applicationMoved(application.id, 'cerpana', index);
        }
      }
    }, [_vm._v(" ČERPAŤ ")]) : _vm._e()])]), _c('div', {
      staticClass: "bold bl-color"
    }, [_vm._v(" " + _vm._s(application.sadzba_schvalena !== null ? application.sadzba_schvalena : application.sadzba_pozadovana) + " "), _c('span', {
      staticClass: "upper-index"
    }, [_vm._v("%")])])]), application.stage === 'prerusena' ? _c('div', {
      staticClass: "ziadost-footer"
    }, [_c('img', {
      attrs: {
        "src": require("@/images/application-check-button.svg"),
        "width": "50",
        "alt": ""
      }
    }), _c('span', {
      staticClass: "text"
    }, [_vm._v(" " + _vm._s(application.dovod_prerusenia) + " ")])]) : _vm._e()]);
  })], 2), _c('objects-remove-pop-up', {
    attrs: {
      "objects-component": 'MortgageApplicationsObjects',
      "show": _vm.show,
      "objects": _vm.getRemovedApplications()
    },
    on: {
      "restore": function restore($event) {
        return _vm.restoreApplication($event);
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }